module.exports = __webpack_public_path__ + "img/device-locked.9533f895.svg";